module.exports = __webpack_public_path__ + "img/anne_scheel.9c303d3e.png";